import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Label from '@cimpress/react-components/lib/Label';
import has from 'lodash/has';
import { withTranslation, Trans } from 'react-i18next';
import ReadMorePopover from '../../common/ReadMorePopover';
import TermInfoDrawer from './TermInfoDrawer';
import { selectTerm, removeTerm } from '../../../reducers/termselect/actions';
import { textOverflowEllipsisStyle } from '../../common/CommonCss';

class NameCell extends PureComponent {
  static propTypes = {
    original: PropTypes.objectOf(PropTypes.any).isRequired,
    value: PropTypes.string,
    selectMultipleTerms: PropTypes.bool
  };

  onSelect = (e, term) => {
    const { onSelectTerm, onRemoveTerm, selectedTerms } = this.props;
    const { termId, revisionId } = term;
    if (has(selectedTerms, `${termId}${revisionId}`)) {
      return onRemoveTerm(term);
    }
    return onSelectTerm(term);
  };

  termClickEvent = e => {
    // 0 -> left click, 1 -> middle click, 2 -> right click
    if (e.button === 1 || e.ctrlKey) {
      e.stopPropagation();
    } else {
      e.preventDefault();
    }
  };

  render() {
    const { t, original, value, selectMultipleTerms } = this.props;
    if (selectMultipleTerms) {
      return (
        <div>
          <TermInfoDrawer termRevision={original} latestRevisionId={original.revisionId}>
            <a
              href={`${original.termId}/${original.revisionId}`}
              className={textOverflowEllipsisStyle}
              onClick={this.termClickEvent}>
              {original.isNew ? <b>{value || ''} [NEW]</b> : value || ''}
            </a>
          </TermInfoDrawer>
        </div>
      );
    }

    const highestPrecedenceAdditionalDetails = (
      <div>
        <br />
        <Trans i18nKey="contractsTable:effectiveContractAdditionalDetails">
          For a contract to be effective, it needs to be approved and take the
          <a
            href="https://cimpress-support.atlassian.net/wiki/spaces/CI/pages/288981293/Contract+Manager#ContractManager-PricingTypesWhichContractTermTakesPrecedence?"
            target="_blank"
            rel="noopener noreferrer">
            highest precedence
          </a>
          <i className="fa fa-external-link" />
        </Trans>
        <br />
        <br />
        {t('contractsTable:onlyOneEffectiveContractDetails')}
        <br />
        <br />
        <div>
          <Trans i18nKey="contractsTable:effectiveContractDetails">
            This contract is effective for <b>{{ sku: original.effectiveSku }}</b> between buyer{' '}
            <b>{{ buyer: original.buyer.name }}</b> and seller <b>{{ seller: original.seller.name }}</b>
          </Trans>
        </div>
      </div>
    );

    return (
      <div>
        <TermInfoDrawer termRevision={original} latestRevisionId={original.revisionId}>
          <a
            href={`${original.termId}/${original.revisionId}`}
            className={textOverflowEllipsisStyle}
            onClick={this.termClickEvent}>
            {original.isNew ? <b>{value || ''} [NEW]</b> : value || ''}
          </a>
        </TermInfoDrawer>
        {original.isEffective && (
          <ReadMorePopover
            variety="popover"
            contents={t('contractsTable:effectiveContractPopover')}
            readMoreContents={highestPrecedenceAdditionalDetails}>
            <Label
              text={
                <div>
                  {t('common:contractStatus.effective')} <i className={`fa fa-question-circle`} />
                </div>
              }
              type="primary"
            />
          </ReadMorePopover>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  selectedTerms: state.termSelectReducer.selectedTerms
});

const mapDispatchToProps = dispatch => ({
  onSelectTerm: term => dispatch(selectTerm(term)),
  onRemoveTerm: term => dispatch(removeTerm(term))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(NameCell));
